var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-bar"},[_c('div',{staticClass:"button-bar__title"},[_c('i',{staticClass:"el-icon-tickets"}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"button-bar__tip"},[_vm._t("tip")],2)]),_c('div',{staticClass:"button-bar__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }